<section class="food99-integracoes integration-page">
  <div class="alert alert-warning" role="alert" *ngIf="!empresa?.exibirBandeiras">
    <i class="k-icon k-i-warning mr-2"></i>
    Para integrar com o 99Food, ative as formas de pagamento com bandeiras.
  </div>

  <ng-container *ngIf="empresa?.exibirBandeiras">
    <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
      <div class="d-flex align-items-center justify-content-between">
        <span><i class="k-icon k-i-warning mr-2"></i>{{mensagemErro}}</span>
        <button type="button" class="close" aria-label="Fechar" (click)="mensagemErro = null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <header class="page-header">
      <div>
        <h2>{{novaIntegracao ? 'Adicionar loja 99Food' : integracaoEmEdicao ? 'Editar integração 99Food' : 'Integrações 99Food'}}</h2>
        <p *ngIf="!novaIntegracao && !integracaoEmEdicao">Gerencie as lojas vinculadas e os serviços ativos da integração.</p>
        <p *ngIf="novaIntegracao || integracaoEmEdicao">Configure a autorização e os serviços disponíveis para esta loja.</p>
      </div>
      <div class="header-actions" *ngIf="!novaIntegracao && !integracaoEmEdicao">
        <button class="btn btn-primary" type="button" (click)="novaIntegracao99Food()"
                [disabled]="carregando" *ngIf="empresa?.id">
          <i class="k-icon k-i-plus mr-1"></i>Adicionar nova loja
        </button>
        <button class="btn btn-outline-warning" type="button" *ngIf="possuiIntegracao()"
                (click)="sincronizarFormasPagamentos()" [disabled]="sincronizando">
          <i class="fas mr-1" [ngClass]="sincronizando ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
          {{sincronizando ? 'Sincronizando...' : 'Sincronizar formas de pagamento'}}
        </button>
      </div>
    </header>

    <div class="alert alert-info" role="status" *ngIf="carregando">
      <i class="fas fa-spinner fa-spin mr-2"></i>Carregando lojas autorizadas no 99Food...
    </div>

    <ng-container *ngIf="novaIntegracao || integracaoEmEdicao; else listagem">
      <button class="back-button" type="button" (click)="canceleEdicao()">
        <i class="fas fa-arrow-left mr-2"></i>Voltar para integrações
      </button>
      <app-form-integracao-99food *ngIf="empresa?.id"
        [empresa]="empresa"
        [integracaoFood99]="novaIntegracao || integracaoEmEdicao"
        [indice]="indiceIntegracao(integracaoEmEdicao)"
        (cancelou)="canceleEdicao()" (removeu)="canceleEdicao()">
      </app-form-integracao-99food>
    </ng-container>

    <ng-template #listagem>
      <div class="summary-grid">
        <article class="summary-card">
          <span class="summary-icon"><i class="fas fa-store"></i></span>
          <div><small>Lojas vinculadas</small><strong>{{obtenhaIntegracoesFood99().length}}</strong></div>
        </article>
        <article class="summary-card order">
          <span class="summary-icon"><i class="fas fa-link"></i></span>
          <div><small>Integrações ativas</small><strong>{{quantidadeAtivas}}</strong></div>
        </article>
        <article class="summary-card">
          <span class="summary-icon"><i class="fas fa-cube"></i></span>
          <div><small>Publicação de catálogo habilitada</small><strong>{{quantidadePublicacaoHabilitada}}</strong></div>
        </article>
      </div>

      <div class="integration-list">
        <div class="empty-state" *ngIf="!possuiIntegracao() && !carregando && !mensagemErro">
          <span class="empty-icon"><i class="fas fa-store"></i></span>
          <h4>Nenhuma loja 99Food vinculada</h4>
          <p>Adicione uma loja para configurar os serviços da integração.</p>
          <button class="btn btn-primary" type="button" (click)="novaIntegracao99Food()" [disabled]="!empresa?.id">
            <i class="k-icon k-i-plus mr-1"></i>Adicionar nova loja
          </button>
        </div>

        <article class="integration-card" *ngFor="let integracao of obtenhaIntegracoesFood99()">
          <div class="integration-main">
            <div class="brand-column">
              <img src="/assets/icons/logo-99food.png" alt="99Food">
              <span class="status-pill" [class.disabled]="integracao.desativado">
                <i class="fas fa-circle"></i>{{integracao.desativado ? 'Desativada' : 'Ativa'}}
              </span>
            </div>
            <div class="details-column">
              <div class="detail-row">
                <span><i class="fas fa-store"></i>Loja</span>
                <strong>{{integracao.nomeLoja || 'Loja 99Food'}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="fas fa-fingerprint"></i>ID da loja</span>
                <strong class="merchant-id">{{integracao.shopId || '—'}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="fas fa-link"></i>ID vinculado</span>
                <strong class="merchant-id">{{integracao.idLoja || '—'}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="far fa-calendar-alt"></i>Desde</span>
                <strong>{{integracao.dataAtivacao ? (integracao.dataAtivacao | date: 'dd/MM/yyyy') : '—'}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="fas fa-shield-alt"></i>Validade do token</span>
                <strong>{{integracao.validadeToken ? (integracao.validadeToken | date: 'dd/MM/yyyy HH:mm') : '—'}}</strong>
              </div>
            </div>
            <div class="api-column">
              <div class="api-status" [class.enabled]="!integracao.desativado">
                <span class="api-icon"><i class="fas fa-shopping-cart"></i></span>
                <div><strong>Recebimento de pedidos</strong><small>{{integracao.desativado ? 'Desabilitado' : 'Habilitado'}}</small></div>
              </div>
              <div class="api-status" [class.enabled]="!integracao.desativado && integracao.publicacaoCatalogoHabilitada">
                <span class="api-icon"><i class="fas fa-cube"></i></span>
                <div><strong>Publicação de catálogo</strong><small>{{!integracao.desativado && integracao.publicacaoCatalogoHabilitada ? 'Habilitada' : 'Desabilitada'}}</small></div>
              </div>
            </div>
          </div>
          <footer class="integration-footer">
            <div class="footer-status">
              <span class="footer-shield"><i class="fas fa-shield-alt"></i></span>
              <div><small>Status da integração</small><strong [class.text-muted]="integracao.desativado">{{integracao.desativado ? 'Desativada' : 'Ativa'}}</strong></div>
            </div>
            <div class="card-actions">
              <button class="btn btn-outline-primary" type="button" (click)="editeIntegracao(integracao)">
                <i class="fas fa-pencil-alt mr-1"></i>Editar
              </button>
            </div>
          </footer>
        </article>
      </div>

      <aside class="api-help">
        <h4><i class="fas fa-info-circle mr-2"></i>Sobre a integração</h4>
        <div class="help-item catalog">
          <span><i class="fas fa-cube"></i></span>
          <div><strong>Publicação de catálogo</strong><p>Habilita a revisão e publicação de produtos pelo canal de venda 99Food.</p></div>
        </div>
        <div class="help-item order">
          <span><i class="fas fa-shopping-cart"></i></span>
          <div><strong>Pedidos</strong><p>Configure a confirmação de pedidos e o tratamento de cancelamentos e reembolsos.</p></div>
        </div>
        <div class="help-item">
          <span><i class="fas fa-store"></i></span>
          <div><strong>Operação da loja</strong><p>Consulte o status da loja e configure sua abertura e fechamento.</p></div>
        </div>
      </aside>
    </ng-template>
  </ng-container>
</section>
